import { render } from "./SelectSimple.vue?vue&type=template&id=1c4750b2&scoped=true"
import script from "./SelectSimple.vue?vue&type=script&lang=js"
export * from "./SelectSimple.vue?vue&type=script&lang=js"

import "./SelectSimple.vue?vue&type=style&index=0&id=1c4750b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4750b2"]])

export default __exports__